import script from "./high-risk-label.vue?vue&type=script&setup=true&lang=js"
export * from "./high-risk-label.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__